import React, { useState, useEffect, useRef } from 'react';
import { Modal, Button, Spinner, Form } from 'react-bootstrap';
import { FaCog } from 'react-icons/fa'; // или любой ваш набор иконок
import api from '../../services/api';
import YandexDiskCookiesModal from './YandexDiskCookiesModal';


const STORAGE_KEY = 'yandex_disk_cookies';

const YandexDiskSearchModal = ({ show, onHide, articles }) => {
  const [loading, setLoading] = useState(false);
  const [showCookiesModal, setShowCookiesModal] = useState(false);
  const [result, setResult] = useState(null);
  const abortControllerRef = useRef(null);

  useEffect(() => {
    if (show) {
      // сбрасываем состояние при открытии
      setResult(null);
      setLoading(false);
      runSearch();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [show]);

  const runSearch = async () => {
    setLoading(true);
    setResult(null);

    const controller = new AbortController();
    abortControllerRef.current = controller;

    try {
      const cookies = localStorage.getItem(STORAGE_KEY) || '';
      
      const response = await api.patch(
        '/orders/search-on-yandexdisk',
        { 
          Cookies: cookies,
          Articles: articles || [], 
        },
        { signal: controller.signal }
      );

      setResult(response.data);
    } catch (err) {
      if (err.name === 'CanceledError' || err.code === 'ERR_CANCELED') {
        // запрос отменён — просто выходим без ошибки
        return;
      }
      setResult({
        successArticle: [],
        successFiles: [],
        errorArticle: [],
        downloadUrl: '',
        error: err?.response?.data?.error || err.message || 'Неизвестная ошибка',
      });
    } finally {
      setLoading(false);
      abortControllerRef.current = null;
    }
  };

  const handleCancel = () => {
    if (abortControllerRef.current) {
      abortControllerRef.current.abort();
    }
    onHide();
  };

  const handleDownload = () => {
    if (result?.downloadUrl) {
      window.open('https:' + result.downloadUrl, '_blank');
    }
  };

  const hasError = !!result?.error;
  const canDownload = !loading && !hasError && result?.downloadUrl;

  return (
    <>
      <Modal show={show} onHide={handleCancel} size="lg" centered>
        <Modal.Header closeButton>
          <Modal.Title className="d-flex align-items-center justify-content-between w-100 me-3">
            <span>Поиск макетов на Яндекс Диске</span>
            <FaCog
              role="button"
              title="Настройки Cookies"
              style={{ cursor: 'pointer' }}
              onClick={() => setShowCookiesModal(true)}
            />
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {loading ? (
            <div className="d-flex flex-column align-items-center py-4">
              <Spinner animation="border" role="status" />
              <span className="mt-2">Идёт поиск макетов...</span>
            </div>
          ) : (
            result && (
              <>
                <Form.Group className="mb-3">
                  <Form.Label>Найденные файлы</Form.Label>
                  <Form.Control
                    as="textarea"
                    readOnly
                    rows={6}
                    value={(result.successFiles || []).join('\n')}
                    placeholder="Нет найденных файлов"
                  />
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label>Ненайденные артикулы</Form.Label>
                  <Form.Control
                    as="textarea"
                    readOnly
                    rows={4}
                    value={(result.errorArticle || []).join('\n')}
                    placeholder="Нет ненайденных артикулов"
                  />
                </Form.Group>

                {hasError && (
                  <div className="text-danger">{result.error}</div>
                )}
              </>
            )
          )}
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={handleCancel}>
            Отмена
          </Button>
          {canDownload && (
            <Button variant="success" onClick={handleDownload}>
              Скачать макеты
            </Button>
          )}
        </Modal.Footer>
      </Modal>

      <YandexDiskCookiesModal
        show={showCookiesModal}
        onHide={() => setShowCookiesModal(false)}
      />
    </>
  );
};

export default YandexDiskSearchModal;